export default __webpack_public_path__ + "media/images/carousel/18-73d95b77016ffe85c98e7b9778c710c7.jpg";